import { Copy } from '@phosphor-icons/react';

export default Copy;
